__turbopack_context__.v({
  "icon": "_w7Ykq_icon",
  "thumb": "_w7Ykq_thumb",
  "wrapper": "_w7Ykq_wrapper" + " " + __turbopack_context__.i(248112)["focusOutline"],
});
